// S6.3, I11's second clause: A SIGN-IN ARRIVES BY A SINGLE-USE TICKET.
//
// A coach opening a client's result from the CRM, or a coach's test client
// opening an assessment from the portal's self-test, used to arrive with
// `?authToken=<custom token>`, reusable for an hour by anyone who read it.
// Now the sender mints a two-minute, single-use ticket (apc-crm
// `createSignInTicket`) and the URL carries `?signin=<ticket>`. This takes it
// off the address bar before anything else, spends it once with
// `redeemSignInTicket` for this site, and signs in with the token it answers.
// A refused or failed ticket falls back to the sign-in gate, as before.

export const SIGN_IN_PARAM = 'signin';

export async function takeSignInTicket({ location, replaceState, redeem, signIn }) {
  const params = new URLSearchParams(location.search);
  const ticket = params.get(SIGN_IN_PARAM);
  if (!ticket) return;
  params.delete(SIGN_IN_PARAM);
  replaceState(location.pathname + (params.toString() ? `?${params.toString()}` : '') + location.hash);
  try {
    const { token } = await redeem({ ticket, to: 'assessment' });
    await signIn(token);
  } catch (err) {
    console.error('The sign-in ticket could not be used; falling back to the sign-in gate:', err);
  }
}
